import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { crmColors } from "../../theme/colors";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "bullet",
  "align",
  "link",
];

//Created By Cursor — strip tags for plain-text previews / empty checks
export const stripAnnouncementHtml = (html) =>
  String(html || "")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/p>/gi, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

//Created By Cursor
const AnnouncementRichTextEditor = ({ value, onChange, label = "Message" }) => (
  <Box>
    <Typography
      sx={{
        fontSize: 11.5,
        fontWeight: 800,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        color: crmColors.text.secondary,
        mb: 0.85,
      }}
    >
      {label}
    </Typography>
    <Box
      sx={{
        borderRadius: "10px",
        border: `1px solid ${crmColors.border.default}`,
        overflow: "visible",
        bgcolor: "#fff",
        "&:focus-within": {
          borderColor: crmColors.primary.main,
          boxShadow: `0 0 0 3px ${alpha(crmColors.primary.main, 0.12)}`,
        },
        "& .ql-toolbar.ql-snow": {
          border: "none",
          borderBottom: `1px solid ${crmColors.border.default}`,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          bgcolor: alpha(crmColors.primary.main, 0.03),
          px: 1,
          py: 0.5,
          flexWrap: "wrap",
        },
        "& .ql-container.ql-snow": {
          border: "none",
          fontFamily: "inherit",
          fontSize: 14,
          minHeight: 140,
        },
        "& .ql-editor": {
          minHeight: 140,
          maxHeight: 260,
          overflowY: "auto",
          color: crmColors.text.primary,
          lineHeight: 1.5,
        },
        "& .ql-editor.ql-blank::before": {
          color: crmColors.text.disabled,
          fontStyle: "normal",
        },
        "& .ql-snow .ql-stroke": { stroke: crmColors.text.secondary },
        "& .ql-snow .ql-fill": { fill: crmColors.text.secondary },
        "& .ql-snow .ql-picker": { color: crmColors.text.secondary },
        "& .ql-snow .ql-picker.ql-expanded .ql-picker-options": {
          zIndex: 20,
        },
        "& .ql-snow.ql-toolbar button:hover .ql-stroke, & .ql-snow.ql-toolbar button.ql-active .ql-stroke":
          {
            stroke: crmColors.primary.main,
          },
        "& .ql-snow.ql-toolbar button:hover .ql-fill, & .ql-snow.ql-toolbar button.ql-active .ql-fill":
          {
            fill: crmColors.primary.main,
          },
      }}
    >
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder="Write the announcement message…"
      />
    </Box>
  </Box>
);

export default AnnouncementRichTextEditor;
